export default (len = 32) => {
	let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(
			''
		),
		timestamp = `${new Date().getTime()}`,
		uuid = timestamp.split(''),
		i;
	len = Math.max(20, len);
	for (i = timestamp.length; i < len; i++)
		uuid[i] = chars[0 | (Math.random() * chars.length)];
	return uuid.join('');
};
